import { Button, Col, Row, Table } from 'antd'
import React from 'react'
import LeftControl from '../../../Components/LeftControl'
import { Grid } from '@material-ui/core'
import { Colors } from '../../../helpers/Colors'
import PageHeader from '../../../Components/PageHeader'
import { useEffect } from 'react'
import { DownloadExportCheckRide, get_checkride_table_by_Id } from '../../../Services/employee'
import { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import moment from 'moment'
import { id } from 'date-fns/locale'
import { CaretLeftOutlined } from '@ant-design/icons'
import GoBack from '../../../Components/GoBackButton/GoBack'
import PageLayout from '../../../Components/LayoutComponents/PageLayout'

const CheckRidePdf = () => {
    const [checkRideData, setCheckRideData] = useState([]);
    const [activeTab, setActiveTab] = useState(1);

    const { state } = useLocation()

    const history = useHistory()
    const location = useLocation
    //  


    const fetchCheckRideDataFromApi = async () => {

        try {
            const data = await get_checkride_table_by_Id(state);
            setCheckRideData(data);
        } catch (error) {
            console.error('Error fetching check ride data:', error);
        }
    };



    useEffect(() => {
        fetchCheckRideDataFromApi();
    }, []);
    useEffect(() => {
        if (location.state) {
            setActiveTab(location.state.activeKey);
        }
    }, [location.state]);
    const handleGoBack = () => {
        // Go back to the previous location
        history.goBack(  {activeKey: 2  });

    };

    const handleExportButtonClick = async () => {

        try {
            const response = await DownloadExportCheckRide(state);
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `CheckRide - ${state?.id}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting data:', error);
        }
    }

    const columns = [
        {
            title: 'Task',
            dataIndex: 'col1',
            key: 'col1',
        },
        {
            title: 'Result',
            dataIndex: 'col2',
            key: 'col2',
        },
        {
            title: 'Points',
            dataIndex: 'col3',
            key: 'col3',
        },
        {
            title: '',
            dataIndex: 'col4',
            key: 'col4',
        },
        {
            title: 'Task',
            dataIndex: 'col5',
            key: 'col5',
        },
        {
            title: 'Result',
            dataIndex: 'col6',
            key: 'col6',
        },
        {
            title: 'Points',
            dataIndex: 'col7',
            key: 'col7',
        },
    ];

    const dataSource = checkRideData?.data?.CheckRideAnswers?.map((answer, index) => ({
        col1: answer.CheckRideQuestion.name,  // Task column
        col2: answer.answer,  // Result column
        col3: answer.score,   // Points column
        key: index,
    }));
    const extraRowData = {
        col1: <strong>Total</strong>,
        col2: '',
        col3: <strong> {checkRideData?.data?.totalScore}</strong>
    };


    const dataSourceWithExtraRow = Array.isArray(dataSource)
        ? [...dataSource, extraRowData]
        : [extraRowData];

    const first12Rows = dataSourceWithExtraRow?.slice(0, 12);
    const last12Rows = dataSourceWithExtraRow?.slice(-13);


    const CustomRow = ({ label, value }) => (
        <div style={{ display: 'flex', marginBottom: '10px', gap: "15px" }}>
            <p className='bold'>{label}:</p>
            <p style={{ marginTop: '3px' }}>{value || 'N/A'}</p>
        </div>
    );
    const CustomRow2 = ({ label, value }) => (
        <div style={{ display: 'flex', marginBottom: '10px', }}>
            <div style={{ flex: '0 0 51%' }}>
                <p className='bold'>{label}:</p>
            </div>
            <div style={{ flex: '0 0 30%' }}>
                <p style={{ marginTop: '3px' }}>{value || "N/A"}</p>
            </div>
        </div>
    );


    let info = [
        { label: "Engineer", value: checkRideData?.data?.Engineer?.firstName + " " + checkRideData?.data?.Engineer?.lastName },
        { label: "Lead Locomotive ID", value: checkRideData?.data?.locomotiveConsist },
        { label: "Start Date", value: checkRideData?.data?.date ? moment(checkRideData?.data?.date).utc().format('MM-DD-YYYY') : "N/A" },
        { label: "End Date", value: checkRideData?.data?.endDate ? moment(checkRideData?.data?.endDate).utc().format('MM-DD-YYYY') : "N/A" },
        { label: "Start Time", value: checkRideData?.data?.time ? moment(checkRideData?.data?.time, "HH:mm:ss").format('h:mm a') : "N/A" },
        { label: "End Time", value: checkRideData?.data?.endTime ? moment(checkRideData?.data?.endTime, "HH:mm:ss").format('h:mm a') : "N/A" },
        { label: "Train Consist-Loads", value: checkRideData?.data?.TCLoads },
        { label: "Type", value: checkRideData?.data?.Type },
        { label: "Train Consist-Empties", value: checkRideData?.data?.TCEmpties },
        { label: "Evaluator", value: checkRideData?.data?.Evaluator?.firstName + " " + checkRideData?.data?.Evaluator?.lastName },
        { label: "Train Consist-Total Tonnage", value: checkRideData?.data?.TCTotalTonage },
        { label: "Total Miles Traveled", value: checkRideData?.data?.TMTraveled },
        { label: "Result", value: checkRideData?.data?.totalScore }
    ]

    return (
        <PageLayout className="Liq-Container">
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">Engineer Evaluation Report</Grid>

                <div style={{ padding: '8px', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <div style={{ flex: 1 }}>
                            <GoBack path="/safety-testing" state={{ activeKey: 2 }} />
                        </div>
                        <div>
                            <Button onClick={handleExportButtonClick} style={{ background: Colors.mainBlue, color: 'white', marginTop: '10px' }}>
                                Export
                            </Button>
                        </div>
                    </div>
                </div>

                <Row>
                    <Col md={19}>

                        <div style={{ display: "grid", gridTemplateColumns: "60% 40%" }}>
                            {info?.map(x => <CustomRow label={x?.label} value={x?.value} />)}
                        </div>
                      
                    </Col>
                    <Col md={5}>

                        <p className='bold'>Comment</p>
                        {checkRideData?.data?.Comments}
                    </Col>
                </Row>
            </Grid>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: '10px' }}>
             
                <Table
                    style={{ width: '49%' }}
                    columns={
                        [
                            { title: 'Task', dataIndex: 'col1', key: 'col1' },

                            {
                                title: 'Result',
                                dataIndex: 'col2',
                                key: 'col2',
                                render: (text, record) => (
                                    <span style={{ color: text == 'YES' ? 'black' : text == 'N/A' ? 'black' : 'black' }}>
                                        {text == 'YES' ? 'PASS' : text == 'N/A' ? 'N/A' : 'COACH'}
                                    </span>
                                ),
                            },

                            {
                                title: 'Points',
                                dataIndex: 'col3',
                                key: 'col3',
                                render: (text, record) => (
                                    <span style={{ color: record.col2 == 'No' ? 'red' : 'black' }}>
                                        {record.col2 == 'NO' ? `-${text}` : ''}
                                    </span>
                                ),
                            },
                        ]
                    }
                    dataSource={Array.isArray(first12Rows) ? first12Rows : []}
                    pagination={false}
                />

                <Table
                    style={{ width: '49%' }}
                    columns={[
                        { title: 'Task', dataIndex: 'col1', key: 'col1' },
                        {
                            title: 'Result',
                            dataIndex: 'col2',
                            key: 'col2',
                            render: (text, record) => (
                                <span style={{ color: text === 'YES' ? 'black' : text === 'N/A' ? 'black' : 'black' }}>
                                    {text === 'YES' ? 'PASS' : text == 'NO' ? 'COACH' : text}
                                </span>
                            ),
                        },
                        {
                            title: 'Points',
                            dataIndex: 'col3',
                            key: 'col3',
                            render: (text, record) => (
                                <span style={{ color: record.col2 === 'No' ? 'red' : '' }}>
                                    {record.col2 == '' ? text : record.col2 === 'NO' ? `-${text}` : ''}
                                </span>
                            ),
                        },
                    ]}
                    dataSource={Array.isArray(last12Rows) ? last12Rows : []}
                    pagination={false}
                />


            </div>
        </PageLayout>
    )
}

export default CheckRidePdf